import { Fragment } from 'react';
import { Block } from '../../block';
import styles from './style.module.less';
import { Require } from './required';
import type { HighlighterProps } from './types';

export function Highlighter(props: HighlighterProps): React.ReactElement {
  const { title = '', keyword } = props;
  const titles = (keyword != null && keyword.trim().length > 0)
    ? title.split(keyword)
    : [title];
  return (
    <div className={props.className} style={props.style}>
      {titles.map((item, index) => (
        <Fragment key={`${item}-${index}`}>
          <span
            data-gramm='false'
            dangerouslySetInnerHTML={{ __html: item.replace(/\n/g, '<br>') }}
          />
          <Block if={index < (titles.length - 1)}>
            <span data-key='highlighter' className={styles.highlight}>{keyword}</span>
          </Block>
        </Fragment>
      ))}

      <Require require={props.require} />
    </div>
  );
}
